import * as server from "@/utils/http"

export const _getInstitutionList = params => server.getByStreetCode("/institution/selectPages", params); // 列表
export const _delInstitution = params => server.getByStreetCode("/institution/delete", params); // 删除
export const _editInstitution = params => server.postByStreetCode(params.id ? "/institution/update" : "/institution/save", params); // 编辑/创建
export const _getBaseData = params => server.getByStreetCode("/institution/getBaseData", params);
export const _findByStreetCode=params=> server.getByStreetCode("/institution/findByStreetCode",params)

export const _findByRoleId=params=> server.getByStreetCode("/institution/findByRoleId",params)

export const _findByAreaCode=params=> server.getByStreetCode("/institution/findByAreaCode",params)

export const _searchSelectByKey = params => server.get("/institution/searchSelect",params);
